import useSWR from 'swr';
import usePublicMode from '../../../hooks/usePublicMode';

export default function useFeaturedPlugins() {
  const fetcher = (url) => fetch(url).then((res) => res.json().then((data) => data.plugins));
  const { urlPrefixApiPlugins } = usePublicMode();
  const { data: featuredPlugins, error, isLoading } = useSWR(`${urlPrefixApiPlugins}/api/featured-plugins/list`, fetcher);

  return { featuredPlugins, isLoading, error };
}
